'use strict';

// Tracker should be loaded via CDN prior to using this module.

var Tracking = {
  init: function init() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (window) {
      var techPlatform = params.techPlatform || 'ssg';
      tracker.initialise({
        env: params.environment || process.env.NODE_ENV || 'production',
        service: params.service || 'seo',
        schemaVersions: params.schemaVersions || {}
      });
      var options = {};
      if (params.agent && typeof params.agent === 'string') options.agent = params.agent;
      tracker.page('landing', options);
      this.inline('tech_platform', techPlatform);
      if (params.templateGroup) this.inline('template_group', params.templateGroup);
    } else console.log('No window, TRACKER NOT LOADED');
  },
  test: function test(data) {
    if (!tracker || !data) return;
    tracker.track('test', data);
  },
  inline: function inline(name, value) {
    tracker.inline('auto_capture', { name: name, value: value });
  },
  track: function track(name, value, type) {
    if (!tracker) return;
    if (!type) {
      // We are doing an auto_capture as default which is now a tracker.inline
      // which autogenerates the page_action_id that we need
      this.inline(name, value);
      return;
    }
    if (type === 'test') {
      // We were meant to perform a split test event here so fire off to that instead
      if (!name) this.test(value);else this.test(name);
      return;
    }
    var dataAttributes = {
      action: {
        name: name,
        value: value
      }
    };
    if (!name) {
      dataAttributes = value;
    }
    // Ok we have the information now so lets track
    tracker.track(type, dataAttributes);
  }
};

module.exports = Tracking;


// WEBPACK FOOTER //
// ./_plugins/lib/tracker.js